export default {"src":"/_next/static/media/0x0dc808adce2099a9f62aa87d9670745aba741746.8d8e3ad1.svg","height":128,"width":128,"blurWidth":0,"blurHeight":0};